import { useEffect, useMemo, useState } from 'react';
import { useQueryParams } from '@/hooks';
import { InboxFilter } from '../../models';

const useInboxFilter = () => {
  const { getQueryParam, setQueryParams } = useQueryParams();

  const initialFilter: InboxFilter = useMemo(
    () => ({
      sector: {
        id: '',
        name: '',
        isLocked: false,
      },
      shippingId: '',
      documentNumber: '',
      phoneNumber: '',
      statuses: ['PENDING', 'ATTENDING'],
    }),
    []
  );

  const [filter, setFilter] = useState<InboxFilter>({
    ...initialFilter,
    sector: {
      id: getQueryParam('sectorId') || initialFilter.sector.id,
      name: getQueryParam('sectorName') || initialFilter.sector.name,
      isLocked: getQueryParam('sectorLocked') === 'true',
    },
    shippingId: getQueryParam('shippingId') || initialFilter.shippingId,
    documentNumber:
      getQueryParam('documentNumber') || initialFilter.documentNumber,
    phoneNumber: getQueryParam('phoneNumber') || initialFilter.phoneNumber,
  });

  useEffect(() => {
    setQueryParams({
      shippingId: filter.shippingId,
      documentNumber: filter.documentNumber,
      phoneNumber: filter.phoneNumber,
      sectorId: filter.sector.id,
      sectorName: filter.sector.name,
      sectorLocked: filter.sector.isLocked.toString(),
      statuses: filter.statuses.toString(),
    });
  }, [filter]);

  return {
    initialFilter: initialFilter,
    filter: filter,
    setFilter: setFilter,
  };
};

export default useInboxFilter;
